import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { CircularProgress } from '../../utils/materialUI';
import '../../assets/styles/Fatwa.css';
import '../../assets/styles/Announcement.css';
import { listAnnouncement } from '../../actions/AnnouncementActions';

const Announcement = (props) => {
    const { match: { params }, listAnnouncement: listAnnouncementAction } = props;

    useEffect(() => {
        const announcementId = params.announcementId;
        listAnnouncementAction(announcementId);
    }, [params, listAnnouncementAction]);

    const { announcement, isLoading } = props.listAnnouncementReducer;

    return (
        <div>
            {
                isLoading ?
                    <div className="loader"><CircularProgress /></div>
                    : ''
            }
            {
                !isLoading ?
                    <div>
                        {
                            announcement.id ?
                                <div id="qa-header">
                                    <div className="title">Title</div>
                                    <p>{announcement.title}</p>
                                    <br />
                                    <div className="title">Details</div>
                                    <div dangerouslySetInnerHTML={{ __html: announcement.details }} />
                                </div>
                                :
                                <div className="result-not-found">
                                    No announcement found.
                                </div>
                        }
                    </div>
                    : ''
            }
        </div>

    );
};

Announcement.propTypes = {
    match: PropTypes.object.isRequired,
    listAnnouncementReducer: PropTypes.object.isRequired,
    listAnnouncement: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        listAnnouncementReducer: state.listAnnouncementReducer,
    };
}

export default connect(mapStateToProps, { listAnnouncement })(Announcement);
